import * as React from 'react'

type Props = {
  children: React.ReactNode
  companyId: string
}

export const HomeLayout = ({ children, companyId }: Props) => {
  return (
    <div className="module-home tw-flex tw-h-screen  tw-w-full tw-min-w-[900px] tw-max-w-full tw-flex-[1] tw-items-center tw-overflow-hidden  tw-text-content-base">
      <main
        className={`tw-flex tw-mx-1 tw-rounded-lg tw-bg-base-100 tw-border tw-border-base-300 tw-h-[calc(100vh-8px)] tw-flex-1 tw-flex-col tw-overflow-hidden`}
      >
        {children}
      </main>
    </div>
  )
}
